import React, { useEffect, useRef, useState } from 'react';
import SectionWithTitle from '../../components/SectionWithTitle';
import SectionWithTitleContent from '../../components/SectionWithTitleContent';
import IconWithTitle from '../../components/IconWithTitle';
import IconWithDescription from '../../components/IconWithDescription';
// import Papa from 'papaparse';
// import { csv } from './cvsData'
import { importDirectoyFiles } from '../../controller/SimpleFileReader';
// import raw from './csvData/Daycroft Camps in Ann Arbor MI 2.csv';
import CsvReader from '../../controller/CvsReader';

import './styles.css';

// import sections from './data';
// import * as csvArray from '../../data/SummerCamps/'

console.log('\n\n\n\n');
const LocationByCsv = (fileContent, campContent) => {
  const cvsFilesKeys = Object.keys(
    importDirectoyFiles(require.context('./csvData', false, /\.(csv)$/))
  );
  const cvsFilesValues = Object.values(
    importDirectoyFiles(require.context('./csvData', false, /\.(csv)$/))
  );
  // // console.log(cvsRawFiles);
  // // const textArr = [];
  // // console.log(textArr);

  // cvsFilesNames.map(
  //   name => fetch(name).then(response => response.text())
  //   // .then(text => console.log(text))
  // );
  // // Example POST method implementation:
  // async function postData(url = '') {
  //   // Default options are marked with *
  //   const response = await fetch(url);
  //   return response.text(); // parses JSON response into native JavaScript objects
  // }

  // console.log(textArr);

  // if ($currentPage == 'summer.php') {

  //   // Build array of CSV files into memory.
  //   foreach ($summerDescriptionCSVs as $i => $csv) {
  //     $cvsName = preg_split('/[\/\\\]/', $csv)[2];
  //     $cvsTitle = preg_split('/[.]/', $cvsName)[0];
  //     $data = fopen($csv, 'r');

  //     $summerCSVFiles[$i] = array(
  //       'location' => $cvsTitle,
  //       'headers' => fgetcsv($data),
  //       'sessions' => []
  //     );
  //     // Fills an entire table from current CSV file.
  //     while (($line = fgetcsv($data)) !== false) {
  //       // Push current line array onto the description array.
  //       array_push($summerCSVFiles[$i]['sessions'], $line);
  //     }
  //     fclose($data);
  //   }
  //   $summerDescriptionBlocks = getCampBlocks($summerDescriptionPDFs, $summerDescriptionJPGs, $summerCSVFiles);
  // }

  const [csvArray, setCsvArray] = useState([]);
  const [csvFiles, setCsvFiles] = useState([]);

  const processCsv = (name, str, delim = ',') => {
    const headers = str.slice(0, str.indexOf('\r')).split(delim);
    const rows = str.slice(str.indexOf('\r') + 1).split('\r\n');
    // console.log('headers', headers);

    const newFileObject = {
      [name]: rows.map(row => {
        row = row.replace(/\n/, '');
        // console.log('row', row);
        const values = row.split(delim);
        const eachObject = headers.reduce((obj, header, index) => {
          obj[header] = values[index];
          return obj;
        }, {});
        return eachObject;
      }),
    };
    // console.log('newFileObject', newFileObject);

    setCsvArray(csvArray => [...csvArray, newFileObject]);
    // setCsvFiles([...csvFiles, csvArray]);
  };

  useEffect(() => {
    console.log('using effect');
    cvsFilesValues.map((fileName, index) =>
      fetch(fileName)
        .then(response => response.text())
        .then(data => processCsv(cvsFilesKeys[index], data))
    );
  }, []);

  return (
    <div>
      {csvArray.map(csv => {
        const csvName = Object.keys(csv)[0].replace('.csv', '');
        const csvTitle = '';
        const data = '';

        return (
          <div
            key={csvName}
            className='csv-container'
          >
            <div>{csvName}</div>
          </div>
        );
      })}
      {/* {console.log('csvArray', JSON.stringify(csvArray))} */}
      {/* <div>{JSON.stringify(csvArray)}</div> */}
    </div>
  );
};

export default LocationByCsv;
